module.exports = __webpack_public_path__ + "img/result-03.30502f78.svg";